import React from 'react';
import businessData from '../data/businessdata.json';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const FloatingWhatsApp = () => {
  const { t } = useLanguage();
  return (
    <div className="fixed bottom-24 md:bottom-6 right-6 z-50 flex flex-col items-end gap-2 group">
      <div className="bg-white text-gray-800 text-sm font-bold px-4 py-2 rounded-xl shadow-xl opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all whitespace-nowrap hidden md:block border border-gray-100">
        {t('whatsapp.tooltip')}
      </div>
      <a
        href={`https://wa.me/${businessData.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#25D366] hover:bg-[#20bd5a] text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center relative"
        aria-label="Chat on WhatsApp"
      >
        <SafeIcon name="MessageCircle" className="text-3xl" />
        
        {/* Subtle pulse animation */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-[ping_2s_infinite] -z-10"></span>
      </a>
    </div>
  );
};

export default FloatingWhatsApp;